import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuSeparator, ContextMenuTrigger, ContextMenuLabel } from "./ui/context-menu";
import { toast } from "sonner";

// Menu contextuel (clic droit) réutilisable : items = [{ label, icon, onClick, disabled, danger, separator }]
export const RowMenu = ({ items, title, copyText, children }) => {
  const list = items.filter(Boolean);
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent className="w-64 rounded-sm" data-testid="row-context-menu">
        {title && <ContextMenuLabel className="text-xs font-mono text-blue-800 truncate">{title}</ContextMenuLabel>}
        {title && <ContextMenuSeparator />}
        {list.map((it, i) => it.separator ? <ContextMenuSeparator key={i} /> : (
          <ContextMenuItem key={i} disabled={it.disabled} onSelect={it.onClick} className={`text-sm cursor-pointer ${it.danger ? "text-red-600 focus:text-red-700" : ""}`} data-testid={`ctx-${(it.testId || it.label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            {it.icon && <it.icon className="w-4 h-4 mr-2" />} {it.label}
          </ContextMenuItem>
        ))}
        {copyText && <ContextMenuSeparator />}
        {copyText && <ContextMenuItem onSelect={() => { navigator.clipboard?.writeText(copyText); toast.success("Copié : " + copyText); }} className="text-sm cursor-pointer text-slate-600" data-testid="ctx-copy">Copier « {copyText} »</ContextMenuItem>}
      </ContextMenuContent>
    </ContextMenu>
  );
};
